export default [
  {
    path: '/records/quote',
    name: 'recordsQuote',
    component: () => import('@/views/records/quote'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/records/quote/detail',
    name: 'recordsQuoteDetail',
    component: () => import('@/views/records/quote/detail'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/records/policy',
    name: 'recordsPolicy',
    component: () => import('@/views/records/policy'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/records/policy/detail',
    name: 'recordsPolicyDetail',
    component: () => import('@/views/records/policy/detail'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/records/policy/manual/detail',
    name: 'recordsPolicyManualDetail',
    component: () => import('@/views/records/policy/manual-detail'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/records/referral',
    name: 'recordsRefer',
    component: () => import('@/views/records/referral'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/records/referrer',
    name: 'referrerReward',
    component: () => import('@/views/records/referrerReward'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/records/quote/plan',
    name: 'planInfo',
    component: () => import('@/views/records/quote/plan-info'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/records/micropolicy',
    name: 'recordsMicropolicy',
    component: () => import('@/views/records/micropolicyList'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/micropolicy/detail',
    name: 'recordsMicropolicyDetail',
    component: () => import('@/views/records/micropolicy/detail'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/campaigns',
    name: 'recordsMicropolicy',
    component: () => import('@/views/records/micropolicy'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/micropolicy/purchase-detail',
    name: 'MicropolicyPurchaseDetail',
    component: () => import('@/views/records/micropolicy/purchase-detail'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/micropolicy/HDRedeem-detail',
    name: 'MicropolicyHDRedeemDetail',
    component: () => import('@/views/records/micropolicy/purchase-detail'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/micropolicy/import-tracking-number',
    name: 'importTrackingNumber',
    component: () => import('@/views/records/micropolicy/components/import-tracking'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/renewal',
    name: 'Renewal',
    component: () => import('@/views/records/renewal'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/records/micropolicy/referrer-talks-detail',
    name: 'ReferrerTalksDetail',
    component: () => import('@/views/records/micropolicy/components/referrer-talks-detail'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/micropolicy/exclusive-reward-detail/:id',
    name: 'exclusiveDetail',
    component: () => import('@/views/records/micropolicy/components/exclusiveDetail'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/micropolicy/promo-hzmb/:id',
    name: 'promoHzmbDetail',
    component: () => import('@/views/records/micropolicy/components/promo-hzmb/promo-hzmb-detail'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/micropolicy/referrer-bonus-detail/:id',
    name: 'exclusiveDetail',
    component: () => import('@/views/records/micropolicy/components/referBonusDetail'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/micropolicy/incentive-bonus-detail/:id',
    name: 'exclusiveDetail',
    component: () => import('@/views/records/referrerReward/component/incentiveBonusDetail'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/micropolicy/hanberg-cashback/:id',
    name: 'hangerCashbackDetail',
    component: () => import('@/views/records/micropolicy/components/cashback/hangerCashbackDetail'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/micropolicy/flight-delay/:id',
    name: 'flightDelayDetail',
    component: () => import('@/views/records/micropolicy/components/flightDelay/detail'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/micropolicy/pv-renew-promo/:id',
    name: 'pvRenewPromoDetail',
    component: () => import('@/views/records/micropolicy/components/pvRenewPromo/detail'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/extra-benefits/list',
    name: 'recordsExtraBenefitsList',
    component: () => import('@/views/records/extra-benefits-list'),
    meta: {
      keepAlive: false
    },
  },
]
